// Copyright (c) Docugami, Inc. All rights reserved.

import { sdvPreviewHighlightYellow } from "components/shell/presentation/AppStyles";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { useEffect, useState } from "react";
import { selectReportEntryBindingsForCurrentDocument } from "store/reports/selectors";
import { removePreviewChunkSet, setPreviewChunks } from "store/sdvSlice";
import { useReportEntryForSelectedLabel } from "./reportEntryIdForLabel";
import { selectAllBindings } from "store/reports/reportsSlice";
import { arrayEquals } from "utils/ArrayUtils";

export function useSdvPreviewChunks(isLabelEditing: boolean) {
    const [spanIds, setSpanIds] = useState<string[] | undefined>(undefined);
    const folderId = useAppSelector(state => state.sdv.document?.folderId);
    const documentBindings = useAppSelector(selectReportEntryBindingsForCurrentDocument);
    const { entry } = useReportEntryForSelectedLabel();

    useEffect(() => {
        if (!documentBindings || !folderId) return;

        // Flatten all bindings from all entities
        const bindings = selectAllBindings(documentBindings).filter(x => x?.entryId !== entry?.id).flatMap(entity => entity?.bindings || []);
        const newSpanIds = bindings.map(x => x.spanId!) as string[];

        setSpanIds(currentSpanIds => (!currentSpanIds || !arrayEquals(currentSpanIds, newSpanIds)) ? newSpanIds : currentSpanIds);
    }, [documentBindings, folderId, entry]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!!spanIds?.length && !isLabelEditing) {
            dispatch(setPreviewChunks({ id: "all-bindings-preview", chunks: { spanIds: spanIds, color: sdvPreviewHighlightYellow } }))
        }
        else {
            dispatch(removePreviewChunkSet("all-bindings-preview"));
        }
    },
        [spanIds, isLabelEditing, dispatch])
}
